import { Button, Col, Row, Space, Flex, Tag, message } from "antd";
import React, { useEffect, useState } from "react";
import styled from "styled-components";
import { IconViewTemplate, IconEditTemplate } from "@assets";
import IncomeChart from "./IncomeChart";
import {
  Title,
  TopBox,
  TopWrapper,
  BoldText,
  Text,
  GrayCard,
  StepItem,
  StepNoBox,
  TextGray,
} from "./DashboardStyled";
import TopProducts from "./TopProducts";
import TroubleshootVideo from "./TroubleShootVideo";
import Count from "./Count";
import api from "../../api/api";
import { PRIVATE_ROUTE } from "../../route.constants";
import PreviewLinkModal from "../TemplateManagement/Template/PreviewLinkModal/PreviewLinkModal";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";

const RootContainer = styled.div``;

const useSteps = () => {
  const { t } = useTranslation();

  return [
    {
      title: t("step_1_title"),
      content: t("step_1_desc"),
    },
    {
      title: t("step_2_title"),
      content: t("step_2_desc"),
    },
    {
      title: t("step_3_title"),
      content: t("step_3_desc"),
    },
    {
      title: t("step_4_title"),
      content: t("step_4_desc"),
    },
    {
      title: t("step_5_title"),
      content: t("step_5_desc"),
    },
  ];
};


const { HOME, TEMPLATE_MGNT, EDIT_TEMPLATE } = PRIVATE_ROUTE;
const Dashboard = () => {
  const [loading, setLoading] = useState(true);
  const [data, setData] = useState();
  const [businessInfo, setBusinessInfo] = useState();
  const [isValid, setIsValid] = useState(false);
  const [open, setOpen] = useState(false);
  const [domainStatus, setDomainStatus] = useState(null);
  const navigate = useNavigate();
  const [isArchived,setIsArchived] = useState();
  const {t} = useTranslation();
  const steps = useSteps();


  const tags = [
    {
      title: t('language'),
      content:
        data?.storeLanguages?.map((lang) => lang.language).join(", ") ||
        "English",
      color: "#1859FF",
    },
    {
      title: t('currency'),
      content: data?.currency?.name + " (" + data?.currency?.key + ")",
      color: "#1859FF",
    },
    {
      title: t('store_short_code'),
      content: data?.shortCode || "-",
      color: "#1859FF",
    },
  ];
  useEffect(() => {
    getPanelInfo();
    getBusinessInformation();
    checkDomainStatus();
    // eslint-disable-next-line
  }, []);
  // console.log(businessInfo);
  const getBusinessInformation = () => {
    api
      .getBusinessInformation()
      .then(({ data }) => {
        setLoading(false);
        setBusinessInfo(data);
      })
      .catch((error) => {
        message.error(error);
      });
  };
  const getPanelInfo = () => {
    api
      .getPanelInfo()
      .then(({ data }) => {
        setData(data);
      })
      .catch((error) => {
        message.error(error);
      });
  };

  const checkDomainStatus = () => {
    api
      .checkDomainStatus()
      .then(({ data, isValid }) => {
        setLoading(false);
        setDomainStatus(data);
        setIsValid(isValid);
      })
      .catch((error) => {
        message.error(error);
        setIsArchived(error);
      });
  };

  const handleViewTemplate = () => {
    if(isArchived === "Store is archived."){
      return message.error("Store is archived.");
    }
    // check if preview link exists
    if (domainStatus?.domain_name) {
      // check if it's valid
      if (isValid) {
        // open preview link
        window.open(domainStatus?.domain_name);
      } else {
        // extend expired time for preview link
        // message.error("Preview Link Expired!");
        setOpen(true);
      }
      return;
    }
    // create new preview link
    setOpen(true);
  };

  const successCallback = (data) => {
    setDomainStatus(data);
    setIsValid(true);
    window.open(data?.domain_name);
  };


const adminData = localStorage.getItem("admin");
  const admin = adminData ? JSON.parse(adminData) : null;
  const role = admin?.role;

  const handleEditClicked = () => {
    if(isArchived === "Store is archived."){
      return message.error("Store is archived.");
    }
  if(role === "MERCHANT_ADMIN" || role === "TEMPLATE_ADMIN"){
// check if preview link exists
    if (domainStatus) {
      // check if it's valid
      if (isValid) {
        // open edit template link
        navigate(`/${HOME}/${TEMPLATE_MGNT}/${EDIT_TEMPLATE}`);
      } else {
        // extend expired time for preview link
        // message.error("Preview Link Expired!");
        setOpen(true);
      }
      return;
    }

    // create new preview link
    setOpen(true);
  }else{
    message.warning("Access Denied!");
  }
  };

  return (
    <RootContainer>
      <Flex wrap gap={4}>
        <BoldText>{businessInfo?.name?.primary} </BoldText>
        {!!businessInfo?.name?.secondary && (
          <BoldText> ({businessInfo?.name?.secondary})</BoldText>
        )}
      </Flex>
      <Title>{t('dashboard')}</Title>
      <Row gutter={[16, 20]}>
        <Col xs={24}>
          <TopBox>
            <Flex
              style={{ width: "100%" }}
              justify="space-between"
              align="center"
              wrap
              gap={12}
            >
              <TopWrapper>
                <BoldText>{t('template_editor')}</BoldText>
                <Text>
                  {t('dashboard_desc_1')}
                </Text>
                <Flex gap={4} wrap>
                  {tags.map((tag, index) => (
                    <Flex key={index} gap="4px 0" wrap>
                      <Tag
                        color="default"
                        style={{
                          padding: "6px 12px",
                          border: 0,
                          borderRadius: 10,
                          display: "flex",
                          alignItems: "center",
                          gap: "8px",
                        }}
                      >
                        <Text>{tag.title}:</Text>
                        <Text style={{ color: "#1859FF" }}>{tag.content}</Text>
                      </Tag>
                    </Flex>
                  ))}
                </Flex>
              </TopWrapper>
              <Flex gap={12} wrap>
                <Button
                  type="default"
                  icon={<IconViewTemplate />}
                  onClick={handleViewTemplate}
                >
                  {t('view_template')}
                </Button>
                <Button
                  type="primary"
                  icon={<IconEditTemplate />}
                  onClick={handleEditClicked}
                >
                  {t('edit_template')}
                </Button>
              </Flex>
            </Flex>
          </TopBox>
        </Col>
        <Row gutter={[12, 12]} style={{ padding: "0 8px" }}>
          <Col xs={24} md={8} xl={4}>
            <Row gutter={[0, 12]}>
              <Count />
            </Row>
          </Col>
          <Col xs={24} md={16} xl={12}>
            <IncomeChart currency_code={data?.currency?.key} />
          </Col>
          <Col xs={24} xl={8}>
            <TopProducts />
          </Col>
        </Row>
        <Col xs={24} md={12}>
          <GrayCard>
            <Text>{t('step_by')}</Text>
            {steps.map((item, index) => (
              <StepItem key={index}>
                <StepNoBox>{index + 1}</StepNoBox>
                <Space direction="vertical">
                  <BoldText>{item.title}</BoldText>
                  <TextGray>{item.content}</TextGray>
                </Space>
              </StepItem>
            ))}
          </GrayCard>
        </Col>
        <Col xs={24} md={12}>
          <TroubleshootVideo />
        </Col>
      </Row>
      <PreviewLinkModal
        open={open}
        handleClose={() => setOpen(false)}
        successCallback={successCallback}
        expired={!isValid && !!domainStatus?.domain_name}
        newLink={!domainStatus?.domain_name}
        domain={domainStatus?.domain_name}
      />
    </RootContainer>
  );
};

export default Dashboard;
